import React from 'react';
import { Box, useTheme } from '@mui/material';

interface IconBoxProps {
  children: JSX.Element;
  optionalStyles?: React.CSSProperties;
}

export function IconBox({ children, optionalStyles }: IconBoxProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        width: theme.spacing(5),
        height: theme.spacing(5),
        padding: theme.spacing(1),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        ...optionalStyles,
      }}
    >
      {children}
    </Box>
  );
}
